import _ from 'lodash';
import { estimateTax } from '@/apis/tax';
import { getCurrency } from "@/utils/currency";
import {getDefaultCvvReAuthInfo} from "@/store/modules/payment";
import { BILLING_CYCLE } from '@/common/constants';
import { isEmptyVal } from '@/utils';

const state = {
  taxes: [],
  isTaxEstimatedBefore: false,
  isTaxUpdateAttempted: false,
  isLoadingTax: false,
}

const getters = {
  getTaxes: (state) => state.taxes,
  isTaxEstimatedBefore: state => state.isTaxEstimatedBefore,
  isTaxUpdateAttempted: state => state.isTaxUpdateAttempted,
  isLoadingTax: state => state.isLoadingTax,
  getPlancodeMapTax(state) {
    return state.taxes.reduce((acc, x) => {
      acc[x.planCode] = x.tax.reduce((amount, y) => {
        return amount + y.taxAmount;
      }, 0);
      return acc;
    }, {});
  },
  getCycledTaxTotalAmount(state, getter) {
    const { getSelectedPlans, getPlancodeMapTax } = getter;
    const list = [
      getSelectedPlans.filter(x => x.billing_cycle === BILLING_CYCLE.MONTHLY),
      getSelectedPlans.filter(x => x.billing_cycle === BILLING_CYCLE.ANNUAL),
      getSelectedPlans.filter(x => x.billing_cycle === BILLING_CYCLE.QUARTERLY),
      getSelectedPlans.filter(x => x.billing_cycle === BILLING_CYCLE.TWO_YEARS),
      getSelectedPlans.filter(x => x.billing_cycle === BILLING_CYCLE.THREE_YEARS),
    ].map(plans => {
      return plans.reduce((acc, x) => {
        const amount = getPlancodeMapTax[x.plan_code] ?? 0;
        return acc + amount;
      }, 0);
    })
    return {
      [BILLING_CYCLE.MONTHLY]: list[0],
      [BILLING_CYCLE.ANNUAL]: list[1],
      [BILLING_CYCLE.QUARTERLY]: list[2],
      [BILLING_CYCLE.TWO_YEARS]: list[3],
      [BILLING_CYCLE.THREE_YEARS]: list[4],
    };
  },
  getTaxTotalAmount: (state, getters) => {
    if (!getters.getSelectedPlans.length) return 0;
    return state.taxes.reduce((acc, x) => {
      const planTax = x.tax.reduce((acc, y) => {
        return acc + y.taxAmount;
      }, 0);
      return acc + planTax;
    }, 0);
  },
  timebasedDiscountPlanEdit: (state, getters) => {
    const { getSelectedPlansWithQuantityMap, couponState, fromCampaignLink } = getters;

    if (window.$context?.is?.edit && !isEmptyVal(couponState?.timeBase) && !fromCampaignLink) {
      const selectedPlanCodeList = Object.keys(getSelectedPlansWithQuantityMap);

      return _.some(couponState.timeBase, (p) => _.includes(selectedPlanCodeList, p?.plan_code));
    }

    return false;
  },
  taxPayload: (state, getters) => {
    const { soldToContact, selectedPlanListPayLoad, couponState, isTaxExempt } = getters;

    return {
      contact: [soldToContact],
      taxExempt: isTaxExempt,
      currency: getCurrency(),
      orderData: {
        planList: selectedPlanListPayLoad,
        coupon: {
          fromCampaignLink: couponState?.fromCampaignLink ?? false,
          code: couponState?.couponCode || '',
        },
      },
      extension: {
        jointsaleCode: getters.partnerRefer?.jointsaleCode,
      },
      timebasedDiscountPlanEdit: getters.timebasedDiscountPlanEdit,
    };
  }
}

const mutations = {
  setTaxes(state, data) {
    state.taxes = data;
  },
  setIsTaxEstimatedBefore(state, is){
    state.isTaxEstimatedBefore = is;
  },
  setIsTaxUpdateAttempted(state, is){
    state.isTaxUpdateAttempted = is;
  },
  setIsLoadingTax(state, is) {
    state.isLoadingTax = is;
  }
}

const actions = {
  async estimateTax({ commit, getters }) {
    commit('setTaxes', []);
    const { taxPayload, paymentMethodUpdated } = getters;
    const { result, status } = await estimateTax(taxPayload);
    commit('setIsTaxEstimatedBefore', true);
    if (!status) return;
    const { taxEstimate = [], cvvReAuth = getDefaultCvvReAuthInfo()} = result;
    commit('setTaxes', taxEstimate);
    if (!paymentMethodUpdated) {
      commit('setCvvReAuthInfo', cvvReAuth);
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
}
